/** @format */

import axios from "axios";

const getBaseUrl = () => {
  const hostname = window.location.hostname;
  if (hostname === "localhost") return "http://localhost:8000/apiV1/";
  if (hostname === "app.co-build.in") return "https://cobuild.trixno.com/apiV1/";
  return "https://devapi.co-build.in/apiV1/";
};

const BASE_URL = getBaseUrl();

export { BASE_URL };

export const authFetcher = async (url) => {
  try {
    const { data } = await axios.get(url);
    return data;
  } catch (error) {
    throw error;
  }
};
